<template>
  <footer>
    <div class="footer-links">
      <a href="https://webmo.info/imprint" target="_blank" rel="noopener">Imprint</a>
      <a href="https://webmo.info/contact" target="_blank" rel="noopener">Contact</a>
      <a href="https://webmo.info/privacy" target="_blank" rel="noopener">Privacy policy</a>
      <a href="https://webmo.info/terms-conditions" target="_blank" rel="noopener">Terms and Conditions</a>
    </div>
    <div class="footer-copyright uk-text-small">© energypedia consult GmbH {{copyrightYear}}</div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',

  data() {
    return {
      copyrightYear: null,
    };
  },

  created() {
    this.copyrightYear = new Date().getFullYear();
  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
footer {
  width: 100%;
  height: 11rem;
  padding-top: 2rem;
  text-align: center;
  background: #eeeeee;

 a {
    display: inline-block;
    height: 40px;
    margin: 0 0.1rem;
    padding: 10px 15px;
    font-size: 14px;
    color: #333;
    line-height: 40px;
    vertical-align: middle;
  }

  a:hover {
    color: #333;
    background: #f5f5f5;
    text-decoration: none;
  }
}

.footer-copyright {
  margin-top: 5rem;
}
</style>
